import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Form, Spinner, Alert } from 'react-bootstrap';
import {
  fetchCrmInstitutesById,
  updateCrmInstitute
} from '../../../services/crmInstituteService';
// import { createContact } from '../../../services/contactService';

export const EditInstitute = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Institute ID for editing

  const [formData, setFormData] = useState({
    institute_name: '',
    status: 'Lead',
    assigned_to: ''
  });
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (id) {
      setLoading(true);
      fetchCrmInstitutesById(id)
        .then(institute => setFormData(institute))
        .catch(() => setError('Failed to load institute'))
        .finally(() => setLoading(false));
    }
  }, [id]);

  const handleChange = (e: React.ChangeEvent<any>) => {
    const target = e.target as HTMLInputElement | HTMLSelectElement;
    setFormData({ ...formData, [target.name]: target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await updateCrmInstitute(id, formData);
      alert('Institute updated successfully');
      navigate('/crm/institutes/all-institutes');
    } catch {
      setError('Error updating institute');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container">
      <h2>Edit Institute</h2>
      {error && <Alert variant="danger">{error}</Alert>}
      {loading ? (
        <Spinner animation="border" />
      ) : (
        <Form onSubmit={handleSubmit}>
          <Form.Group>
            <Form.Label>Institute Name</Form.Label>
            <Form.Control
              type="text"
              name="institute_name"
              value={formData.institute_name}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Status</Form.Label>
            <Form.Select
              name="status"
              value={formData.status}
              onChange={handleChange}
            >
              <option value="Lead">Lead</option>
              <option value="Opportunity">Opportunity</option>
              <option value="Lost">Lost</option>
              <option value="Converted">Converted</option>
            </Form.Select>
          </Form.Group>
          <Button type="submit" disabled={submitting}>
            {submitting ? 'Saving...' : 'Update Institute'}
          </Button>
        </Form>
      )}
    </div>
  );
};
